/**
 * @copyright Microsoft 2020
 */
import * as tslib_1 from "tslib";
import { BaseTelemetryPlugin, isNullOrUndefined, LoggingSeverity, arrForEach, dumpObj, getExceptionName } from "@microsoft/applicationinsights-core-js";
import { PropertiesPluginIdentifier } from "@microsoft/applicationinsights-common";
import { mergeConfig, BehaviorMapValidator, BehaviorValueValidator, BehaviorEnumValidator, _ExtendedInternalMessageId } from './common/Utils';
import { PageAction } from './events/PageAction';
import { AutoCaptureHandler } from "./handlers/AutoCaptureHandler";
import { DomContentHandler } from "./handlers/DomContentHandler";
export { BehaviorMapValidator, BehaviorValueValidator, BehaviorEnumValidator };
var ClickAnalyticsPlugin = /** @class */ (function (_super) {
    tslib_1.__extends(ClickAnalyticsPlugin, _super);
    function ClickAnalyticsPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.identifier = 'ClickAnalyticsPlugin';
        _this.priority = 181;
        return _this;
    }
    ClickAnalyticsPlugin.prototype.initialize = function (config, core, extensions, pluginChain) {
        if (isNullOrUndefined(core)) {
            throw Error("Error initializing");
        }
        config.extensionConfig = config.extensionConfig || [];
        config.extensionConfig[this.identifier] = config.extensionConfig[this.identifier] || {};
        this._config = mergeConfig(config.extensionConfig[this.identifier]);
        _super.prototype.initialize.call(this, config, core, extensions, pluginChain);
        // Default to DOM content handler
        this._contentHandler = this._contentHandler ? this._contentHandler : new DomContentHandler(this._config, this.diagLog());
        var metaTags = this._contentHandler.getMetadata();
        this.pageAction = new PageAction(this, this._config, this._contentHandler, this._config.callback.pageActionPageTags, metaTags, this.diagLog());
        // Default to DOM autoCapture handler
        this._autoCaptureHandler = this._autoCaptureHandler ? this._autoCaptureHandler : new AutoCaptureHandler(this, this._config, this.pageAction, this.diagLog());
        if (this._config.autoCapture) {
            this._autoCaptureHandler.click();
        }
        // Find the properties plugin.
        var _propertiesExtension;
        arrForEach(extensions, function (extension) {
            if (extension.identifier === PropertiesPluginIdentifier) {
                _propertiesExtension = extension;
            }
        });
        // Append Click Analytics Plugin Version to SDK version.
        if (_propertiesExtension && _propertiesExtension.context &&
            _propertiesExtension.context.internal && _propertiesExtension.context.internal.sdkVersion) {
            _propertiesExtension.context.internal.sdkVersion += "_ClickPlugin" + ClickAnalyticsPlugin.Version;
        }
    };
    ClickAnalyticsPlugin.prototype.processTelemetry = function (env, itemCtx) {
        this.processNext(env, itemCtx);
    };
    /**
     * Logs a page action event.
     * @param IPageActionTelemetry
     * @param customProperties Additional data used to filter events and metrics. Defaults to empty.
     */
    ClickAnalyticsPlugin.prototype.trackPageAction = function (pageAction, customProperties) {
        try {
            this.pageAction.trackPageAction(pageAction, customProperties);
        }
        catch (e) {
            this.diagLog().throwInternal(LoggingSeverity.CRITICAL, _ExtendedInternalMessageId.TrackPageActionEventFailed, "trackPageAction failed, page action event will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
        }
    };
    ClickAnalyticsPlugin.Version = "2.6.4";
    return ClickAnalyticsPlugin;
}(BaseTelemetryPlugin));
export { ClickAnalyticsPlugin };
//# sourceMappingURL=ClickAnalyticsPlugin.js.map